import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/solid';
import ProductCard from './ProductCard';

const NewArrivals = ({ products }) => {
  // Son 7 gün içinde eklenen ürünleri filtrele
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const newProducts = products
    .filter(p => {
      const createdDate = new Date(p.created_at);
      return createdDate >= sevenDaysAgo;
    })
    .slice(0, 4); // En fazla 4 ürün göster (2x2 grid)

  if (newProducts.length === 0) return null;

  return (
    <div className="w-full bg-white py-16 my-12">
      <div className="max-w-7xl mx-auto px-4">
        {/* Başlık */}
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-3">
            <div className="bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl p-3 shadow-lg">
              <SparklesIcon className="w-8 h-8 text-white" />
            </div>
            <div>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
                ✨ Yeni Gelenler
              </h2>
              <p className="text-gray-600 mt-1">
                Son 7 günde eklenen ürünlerimiz
              </p>
            </div>
          </div>

          <Link
            to="/products?filter=new"
            className="hidden md:inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-bold px-6 py-3 rounded-full hover:shadow-xl transform hover:scale-105 transition-all"
          >
            Tümünü Gör
            <SparklesIcon className="w-5 h-5" />
          </Link>
        </div>

        {/* Products Grid - 2x2 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {newProducts.map(product => (
            <div key={product.id} className="relative">
              {/* NEW Badge */}
              <div className="absolute top-2 left-2 z-10 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg flex items-center gap-1">
                <SparklesIcon className="w-3 h-3" />
                YENİ
              </div>
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        {/* Mobile "Tümünü Gör" Button */}
        <div className="md:hidden text-center mt-8">
          <Link
            to="/products?filter=new"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-bold px-6 py-3 rounded-full hover:shadow-xl transform hover:scale-105 transition-all"
          >
            Tümünü Gör
            <SparklesIcon className="w-5 h-5" />
          </Link>
        </div>

        {/* Info Banner */}
        <div className="mt-12 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-6 border-2 border-yellow-200">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center text-2xl">
              🎉
            </div>
            <div>
              <h3 className="font-bold text-gray-900 text-lg mb-1">
                Her Hafta Yeni Ürünler!
              </h3>
              <p className="text-gray-600">
                Koleksiyonumuzu düzenli olarak güncelliyoruz. En yeni ürünlerimizi kaçırmamak için bizi takip edin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewArrivals;
